import { render, staticRenderFns } from "./StaticPage.vue?vue&type=template&id=4848dc15&"
import script from "./StaticPage.vue?vue&type=script&lang=js&"
export * from "./StaticPage.vue?vue&type=script&lang=js&"
import style0 from "./StaticPage.vue?vue&type=style&index=0&id=4848dc15&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports